import { RequestStatus } from 'typed/api';
import { ActionType, Action } from 'typed/actions';
import { IReducer, networkActionReducer } from './';
import { Entity, IEntityReducerState, isPaginationSlice, isNetworkArray, isSimpleArray, IEntityReducerCreator } from './entityReducers';
import { deepAssign, deepClone } from 'typed/utils';


const entityAddAllReducer: IEntityReducerCreator = <E extends Entity, T extends ActionType>(def: IEntityReducerState<E>, type: T): IReducer<any, Action<T>> => {
    const nr = networkActionReducer<T, E>(type);
    return function entityAddAllReducer(state: IEntityReducerState<E> | undefined = deepClone(def), action: Action<T>): IEntityReducerState<E> {
        if (action.type === type) {
            let data = isNetworkArray(state) ? state.Data : isSimpleArray(state) ? state : [state];
            switch (action.payload.status) {
                case RequestStatus.UNSYNCED:
                    if (isPaginationSlice(state)) {
                        state = deepAssign(state, {
                            Count: state.Count + action.payload.entities.length,
                            TotalCount: state.TotalCount + action.payload.entities.length
                        })
                    }
                    data = deepAssign(data, [...data, ...action.payload.entities as E[]]);
                    break;

                case RequestStatus.PENDING:
                case RequestStatus.FAILED:
                    data = deepAssign(data, data.map(item => action.payload.entities.getByID(item.ID) ? nr(item, action as any) : item));
                    break;

                case RequestStatus.SUCCEEDED:
                    const response = action.payload.response;
                    let index: number;
                    data = deepAssign(data, data.map(item =>
                        (index = action.payload.entities.getIndexByID(item.ID)) !== -1 ?
                            nr({ ID: (response as unknown as number[])[index], Custom: { internalID: item.ID } } as E, action as any) :
                            item
                    ));
            }

            return isNetworkArray(state) ? deepAssign(state, { Data: data }) : isSimpleArray(state) ? data : data[0];
        }

        return state;
    };
}

export default entityAddAllReducer;
